// extracted by mini-css-extract-plugin
export default {"success":"success-XfxQ0","error":"error-BlObp","maxCharBlock":"maxCharBlock-mnxJh"};